var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-tempalte"},[_c('div',{staticClass:"App"},[_c('vue-confirm-dialog'),_c('div',[(_vm.isTab)?_c('Tabnav'):_vm._e(),_c('div',{class:[!_vm.isNotLogin ? '' : 'inner-block']},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }